<template>
  <div class="page">
    <div class="stripes" aria-hidden="true" />

    <main class="container-home">
      <section class="card" role="region" aria-label="Welcome">
        <div class="brand" ref="brandRef">
          <img
            class="brand__logo"
            src="../assets/images/LogoPerindo.png"
            alt="Logo"
          />
        </div>

        <h1 class="title">Halo, Selamat Datang!</h1>
        <p class="subtitle">Jadilah bagian dari energi baru Indonesia</p>

        <div class="actions">
          <button class="btn btn--primary" type="button" @click="onMasuk">
            Masuk
          </button>

          <button class="btn btn--outline" type="button" @click="onDaftar">
            Daftar Menjadi Anggota
          </button>
        </div>

        <div class="helper">
          <span>Butuh bantuan cara daftar anggota?</span>
          <a class="helper__link" href="https://partaiperindo.com/faq" @click.prevent="onTutorial">Klik Disini</a>
        </div>

        <div class="divider" v-if="banner"/>

        <div class="info" v-if="banner">
          <div class="info__icon" aria-hidden="true">
            <img :src="banner?.image_url" alt="vision plus" width="40" height="40" />
          </div>
          <div class="info__text" v-html="banner?.title" />
        </div>
      </section>

      <section class="stores" aria-label="Download apps">
        <p class="stores__label">Download aplikasi Perindo di:</p>
        <div class="stores__badges">
          <GooglePlayStore
            @click="handleDirect(true)"
            class="pointer"
            style="margin-right: 20px;"
          />
          <AppleAppStore @click="handleDirect(false)" />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import GooglePlayStore from '../assets/icons/google-play-store.vue'
import AppleAppStore from '../assets/icons/apple-app-store.vue'
import { bannerCode } from '@/store'

export default {
  name: "WelcomePerindo",
  components: {
    GooglePlayStore,
    AppleAppStore
  },
  data() {
    return {
      _onResize: null,
      _raf: 0,
      banner: null,
    };
  },
  methods: {
    handleDirect (isGooglePlay) {
      if (isGooglePlay) {
        return window.location.replace(
          'https://play.google.com/store/apps/details?id=com.partaiperindo.app'
        )
      } else {
        return window.location.replace(
          'https://apps.apple.com/id/app/partai-perindo/id1623324981'
        )
      }
    },
    onMasuk() {
      this.$router.push({ name: "Login" })
    },
    onDaftar() {
      this.$router.push({ name: "Daftar" })
    },
    onTutorial() {
      window.open('https://partaiperindo.com/faq', '_blank');
    },
    updateLogoStripeY() {
      const el = this.$refs.brandRef
      if (!el) return

      const rect = el.getBoundingClientRect()
      const centerY = rect.top + rect.height / 2

      document.documentElement.style.setProperty("--logo-center-y", `${centerY}px`)
    },
  },
  async mounted() {
    const res = await this.$store.dispatch('getBanners', bannerCode.bnrRgstHtml)
    this.banner = res?.data
    this._onResize = () => {
      cancelAnimationFrame(this._raf)
      this._raf = requestAnimationFrame(() => {
        this.updateLogoStripeY()
      })
    }

    this.$nextTick(() => {
      this.updateLogoStripeY()
      window.addEventListener("resize", this._onResize, { passive: true })
      window.addEventListener("orientationchange", this._onResize, { passive: true })
    })
  },
  beforeUnmount() {
    window.removeEventListener("resize", this._onResize)
    window.removeEventListener("orientationchange", this._onResize)
    cancelAnimationFrame(this._raf)
  },
};
</script>

<style scoped>
/* ===== base ===== */
.page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  color: #1f2937;
}

.container-home {
  margin-top: 8rem;
  display: flex;
  flex-direction: column;
  place-items: center;
  padding: 56px 18px 36px;
  position: relative;
  z-index: 1;
}

/* ===== background stripes ===== */
.stripes {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.stripes::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 47px;

  top: var(--logo-center-y, 200px);
  transform: translateY(-50%);

  background: linear-gradient(
    90deg,
    #C52128 0%,
    #C52128 20%,
    #223F80 80%,
    #223F80 100%
  );

  /* efek soft */
  opacity: 0.95;
}

/* ===== card ===== */
.card {
  width: min(560px, 100%);
  background: #ffffff;
  border: 2px solid #e6eaf2;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(17, 24, 39, 0.08);
  padding: 26px 26px 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* header logo */
.brand {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

.brand__logo {
  height: 54px;
  width: auto;
  object-fit: contain;
  margin-top: 20px;
}

/* title & subtitle */
.title {
  text-align: center;
  font-size: 28px;
  margin: 6px 0 6px;
  font-weight: 800;
  color: #374151;
}

.subtitle {
  text-align: center;
  margin: 0 0 18px;
  color: #6b7280;
  font-size: 13.5px;
}

/* buttons */
.actions {
  display: grid;
  gap: 12px;
  margin: 10px 0 14px;
}

.btn {
  height: 50px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.02s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.btn:active {
  transform: translateY(1px);
}

.btn--primary {
  background: #1e3a8a;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(30, 58, 138, 0.18);
}

.btn--primary:hover {
  background: #1b357f;
}

.btn--outline {
  background: #ffffff;
  border-color: #3b82f6;
  color: #1e3a8a;
}

.btn--outline:hover {
  background: #f3f7ff;
}

/* helper link */
.helper {
  display: flex;
  justify-content: center;
  gap: 6px;
  font-size: 12.5px;
  color: #6b7280;
  margin-bottom: 14px;
}

.helper__link {
  color: #1d4ed8;
  text-decoration: underline;
  font-weight: 700;
}

.helper__link:hover {
  color: #1e40af;
}

/* divider */
.divider {
  height: 1px;
  background: #e5e7eb;
  margin: 14px 0 16px;
}

/* info box */
.info {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 12px;
  align-items: center;
}

.info__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #111827;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.info__icon img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.info__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.35;
  color: #4b5563;
}

.info__text strong {
  color: #374151;
}

/* bottom stores */
.stores {
  margin-top: 26px;
  text-align: center;
}

.stores__label {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  color: black;
}

.stores__badges {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.badge {
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 18px rgba(17, 24, 39, 0.08);
  transform: translateZ(0);
}

.badge img {
  display: block;
  height: 52px;
  width: auto;
}

@media (max-width: 520px) {
  .stripe {
    top: 120px;
    width: calc(50% - 170px);
    height: 14px;
  }

  .card {
    padding: 22px 18px 18px;
    border-radius: 14px;
  }

  .title {
    font-size: 26px;
  }

  .brand__logo {
    height: 50px;
  }

  .badge img {
    height: 50px;
  }

  .container-home {
    margin-top: 2rem;
  }
  .info__icon {
    width: 52px;
    height: 52px;
  }

  .info {
    grid-template-columns: 52px 1fr;
  }
}
</style>
